import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-aams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-aams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MapService } from "../../../../../map/shared/map.service";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationAamsConstants } from "./create-application-location-aams.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapTools } from "../../../../../map/shared/map.tools";
import { debounceTime } from "rxjs";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let CreateApplicationLocationAamsComponent = class CreateApplicationLocationAamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appControllerService;
    mapService;
    mapTools;
    requestStatusService;
    changeDetectorRefs;
    activeTabIndex;
    advertisementsForm;
    descriptionLabel1 = CreateApplicationLocationAamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationAamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationAamsConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationAamsConstants.VALIDATION_MESSAGES;
    areaOfDisplayFormControlName = CreateApplicationLocationAamsConstants.AREA_OF_DISPLAY_FORM_CONTROL_NAME;
    streetNamesFormControl = CreateApplicationLocationAamsConstants.STREET_NAMES_FORM_CONTROL;
    propertyDescriptionFormControlName = CreateApplicationLocationAamsConstants.PROPERTY_DESCRIPTION_FORM_CONTROL_NAME;
    addressOrStreetFormControlName = CreateApplicationLocationAamsConstants.ADDRESS_OR_STREET_FORM_CONTROL_NAME;
    areaOfDisplayLabel = CreateApplicationLocationAamsConstants.AREA_OF_CONTROL_LABEL;
    streetNamesLabel = CreateApplicationLocationAamsConstants.STREET_NAMES_LABEL;
    propertyDescriptionLabel = CreateApplicationLocationAamsConstants.PROPERTY_DESCRIPTION_LABEL;
    addressOrStreetLabel = CreateApplicationLocationAamsConstants.ADDRESS_OR_STREET_LABEL;
    removeAdvertisementLabel = CreateApplicationLocationAamsConstants.REMOVE_ADVERTISEMENT_LABEL;
    showApplicationTypeNotSelectedPage = true;
    selectedApplicationStatus;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    areaOfDisplayLookups = LookupConstants.AREA_OF_DISPLAY_LOOKUPS_A;
    showPermanentApplicationsFields = false;
    showTemporaryApplicationsFields = false;
    isMapLoaded = false;
    sketchTool;
    selectedGraphic = null;
    AdvertisementTypeNotSelectedMessage = CreateApplicationLocationAamsConstants.ADVERTISEMENT_TYPE_NOT_SELECTED_MESSAGE;
    mapComponent;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, appControllerService, mapService, mapTools, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appControllerService = appControllerService;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToAdvertisement();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.checkAdvertisementType();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.initializeSketchTools();
    }
    loadMetadata(stepMeta) {
    }
    getAdvertisements() {
        return this.advertisementsForm.get("advertisements");
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getAdvertisements().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    onBtnRemoveFeature(featureIndex) {
        this.getAdvertisements().removeAt(featureIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.advertisementsForm = this.aflaModuleStrategyService.form.get("advertisementsForm");
    }
    loadExistingProperty(property) {
        this.setAdvertisementData(property, property.geometry);
    }
    setAdvertisementData(propertyObject, geometry) {
        try {
            this.requestStatusService.showBusySpinner("GetPropertyData");
            let newAdvertisingFormGroup;
            if (propertyObject) {
                newAdvertisingFormGroup = this.setAdvertisingFormGroup(propertyObject, geometry);
            }
            else {
                newAdvertisingFormGroup = this.createAdvertisingFormGroup(geometry);
            }
            const url = this.getGPToolURL();
            const formData = this.getGPToolFormData(geometry);
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    this.setPropertyTrueCentroidData(newAdvertisingFormGroup, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.showFieldsAccordingToChosenApplicationStatus();
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage("propertyData", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                }
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getAdvertisements().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            try {
                this.mapComponent.addGeometriesOnMap(geometries, "Advertising graphics", true);
            }
            catch (e) {
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        }
    }
    subscribeToAdvertisement() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                const objectId = this.featureDataAlternateColumnName(property.attributes, "OBJECTID", "objectid");
                const propertyHasAlreadyBeenAddedBefore = this.checkIfSelectedPropertyHasAlreadyBeenAdded(objectId);
                if (!propertyHasAlreadyBeenAddedBefore) {
                    this.setAdvertisementData(property.attributes, property.geometry);
                }
            }
        });
    }
    checkAdvertisementType() {
        const detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.selectedApplicationStatus = detailsForm.get("isAdvetisingPermanentOrTemporary").value;
        if (detailsForm && this.selectedApplicationStatus) {
            this.showFieldsAccordingToChosenApplicationStatus();
        }
    }
    checkIfSelectedPropertyHasAlreadyBeenAdded(objectId) {
        let featureHasAlreadyBeenAddedBefore = false;
        this.getAdvertisements().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                featureHasAlreadyBeenAddedBefore = true;
                this.appControllerService.showMessage(CreateApplicationLocationAamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("add property");
            }
        });
        return featureHasAlreadyBeenAddedBefore;
    }
    featureDataAlternateColumnName(featureObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(featureObject)) {
            if (key === name1) {
                returnVal = featureObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = featureObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = featureObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setAdvertisingFormGroup(property, geometry) {
        return new FormGroup({
            objectId: new FormControl(this.featureDataAlternateColumnName(property, "OBJECTID", "objectid")),
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            propertyDescription: new FormControl(null),
            address: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    setPropertyTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const advertisementsArray = this.getAdvertisements();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        advertisementsArray?.clear();
        advertisementsArray.push(newFormGroup);
        this.activeTabIndex = advertisementsArray.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    showFieldsAccordingToChosenApplicationStatus() {
        if (this.selectedApplicationStatus?.toLowerCase() === "temporary") {
            this.showApplicationTypeNotSelectedPage = false;
            this.handleTemporaryApplicationSelected();
        }
        if (this.selectedApplicationStatus?.toLowerCase() === "permanent") {
            this.showApplicationTypeNotSelectedPage = false;
            this.handlePermanentApplicationSelected();
        }
        this.changeDetectorRefs.detectChanges();
    }
    handleTemporaryApplicationSelected() {
        this.showPermanentApplicationsFields = false;
        this.showTemporaryApplicationsFields = true;
    }
    handlePermanentApplicationSelected() {
        this.showPermanentApplicationsFields = true;
        this.showTemporaryApplicationsFields = false;
    }
    initializeSketchTools() {
        this.sketchTool = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        if (!this.showApplicationTypeNotSelectedPage && this.selectedApplicationStatus.toLowerCase() === "temporary") {
            this.showMapToolsForTemporaryAdvertisement();
        }
        if (!this.showApplicationTypeNotSelectedPage && this.selectedApplicationStatus.toLowerCase() === "permanent") {
            this.showMapToolsForPermanentAdvertisement();
        }
        this.sketchTool.on("create", (event) => {
            if (event.state === "complete") {
                this.handleSketchComplete(event);
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    handleSketchComplete(event) {
        this.selectedGraphic = event.graphic;
        this.setAdvertisementData(null, this.selectedGraphic.geometry);
    }
    createAdvertisingFormGroup(geometry) {
        return new FormGroup({
            areaOfDisplay: new FormControl(null),
            streetNames: new FormControl(null),
            streetOrAddress: new FormControl(null),
            addressStreetInformation: new FormControl(null),
            propertyDescription: new FormControl(null),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    showMapToolsForTemporaryAdvertisement() {
        this.sketchTool.create("polygon");
        this.sketchTool.visibleElements = CreateApplicationLocationAamsConstants.POLYGON_SKETCH_TOOLS_OPTIONS;
    }
    showMapToolsForPermanentAdvertisement() {
        this.sketchTool.create("point");
        this.sketchTool.visibleElements = CreateApplicationLocationAamsConstants.POINT_SKETCH_TOOLS_OPTIONS;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: false },] }]
    };
};
CreateApplicationLocationAamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-aams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationAamsComponent);
export { CreateApplicationLocationAamsComponent };
